import * as React from 'react';

import { Calendar } from 'lucide-react';

import type { TimeSlot } from '@klareospace/pharos-lib-types';
import { formatTimeWindow } from '@klareospace/pharos-lib-front-utils';
import { IconText, StackedCell, TextCell } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface DateSlotCellProps {
  initialTimeWindow?: TimeSlot;
  requestedTimeWindow?: TimeSlot;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function DateSlotCell({ initialTimeWindow, requestedTimeWindow }: DateSlotCellProps): React.JSX.Element {
  if (!requestedTimeWindow) {
    return <TextCell>—</TextCell>;
  }

  const hasInitialDiff =
    initialTimeWindow &&
    (initialTimeWindow.start !== requestedTimeWindow.start || initialTimeWindow.end !== requestedTimeWindow.end);

  return (
    <IconText className="items-start" icon={Calendar} iconClassName="mt-0.5" size="sm">
      <StackedCell
        primary={formatTimeWindow(requestedTimeWindow)}
        secondary={hasInitialDiff ? formatTimeWindow(initialTimeWindow) : undefined}
        secondaryClassName="line-through"
      />
    </IconText>
  );
}
